/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Outline_Color_AriaInputs */

const en_video_export_outline_color_aria = /** @type {(inputs: Video_Export_Outline_Color_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outline Color`)
};

const fr_video_export_outline_color_aria = /** @type {(inputs: Video_Export_Outline_Color_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur du contour`)
};

const de_video_export_outline_color_aria = /** @type {(inputs: Video_Export_Outline_Color_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konturfarbe`)
};

const it_video_export_outline_color_aria = /** @type {(inputs: Video_Export_Outline_Color_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colore del contorno`)
};

const ru_video_export_outline_color_aria = /** @type {(inputs: Video_Export_Outline_Color_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цвет контура`)
};

const es_video_export_outline_color_aria = /** @type {(inputs: Video_Export_Outline_Color_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color del contorno`)
};

const zh_cn2_video_export_outline_color_aria = /** @type {(inputs: Video_Export_Outline_Color_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`轮廓颜色`)
};

const ja_video_export_outline_color_aria = /** @type {(inputs: Video_Export_Outline_Color_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アウトラインの色`)
};

const hi_video_export_outline_color_aria = /** @type {(inputs: Video_Export_Outline_Color_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रूपरेखा का रंग`)
};

const pt_pt2_video_export_outline_color_aria = /** @type {(inputs: Video_Export_Outline_Color_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cor do contorno`)
};

/**
* | output |
* | --- |
* | "Outline Color" |
*
* @param {Video_Export_Outline_Color_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_outline_color_aria = /** @type {((inputs?: Video_Export_Outline_Color_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Outline_Color_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_outline_color_aria(inputs)
	if (locale === "de") return de_video_export_outline_color_aria(inputs)
	if (locale === "it") return it_video_export_outline_color_aria(inputs)
	if (locale === "ru") return ru_video_export_outline_color_aria(inputs)
	if (locale === "es") return es_video_export_outline_color_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_outline_color_aria(inputs)
	if (locale === "ja") return ja_video_export_outline_color_aria(inputs)
	if (locale === "hi") return hi_video_export_outline_color_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_outline_color_aria(inputs)
	return en_video_export_outline_color_aria(inputs)
});